import BasePointManager from "../../../../../src/managers/BasePointManager";
import { Coord, RedPointRadianInfo } from "../../../../../src/types/Interface";
import { getRandomUniqueNumbers } from "../../../../../src/utils/generator/getRandomUniqueNumbers";
import { normalizeRadian } from "../../../../../src/utils/math/normalizeRadian";
import { CIRCLE_RADIUS, INITIAL_RADIANS } from "../types/Config";
import { eventBus, EnumEventBus } from "./EventBus";
import { moveAllPointAnim } from "../../../../../src/animation/Circle/helpers/drawHelpers";


export default class PointManager extends BasePointManager {
  constructor(cCoord: Coord) {
    super(cCoord, CIRCLE_RADIUS, INITIAL_RADIANS);
    this.setCoord();
    this.draw();

    eventBus.on(EnumEventBus.moveCircum, (v: number) => this.moveCircumPoint(v));
    eventBus.on(EnumEventBus.moveDiameter, (v: number) => this.moveDiameterPoints(v));
    eventBus.on(EnumEventBus.rotateCircle, (v: number) => this.moveAllPoints(v))
    eventBus.on(EnumEventBus.genRndmTriangle, () => this.generateRandomlyRadians())
  }
  setRadian(pointInfoArr: RedPointRadianInfo[], isSlider: boolean = false): void {
    let pIArr = [...pointInfoArr];
    const rest = pIArr.filter(p => p.pTag != "p2");
    if (rest.length == 1) {
      pIArr.push({ pTag: `${rest[0].pTag == "p1" ? "p3" : "p1"}`, radian: normalizeRadian(pIArr[0].radian + Math.PI) })
    }
    this._setRadian(pIArr, isSlider);
  }

  moveCircumPoint(v: number) {
    const pointBTag = this.getRedPoints()[1].tag;
    const pointBRefRadian = this.pointRefRadians[1];
    const radian = pointBRefRadian + v / 100 * (Math.PI / 3)
    const pointInfoArr: RedPointRadianInfo[] = [{ pTag: pointBTag, radian }];
    this.setRadian(pointInfoArr, true);
  }
  moveDiameterPoints(v: number) {
    const pointATag = this.getRedPoints()[0].tag;
    const pointARefRadian = this.pointRefRadians[0];
    const radian = pointARefRadian + v / 100 * (Math.PI / 3)
    const pointInfoArr: RedPointRadianInfo[] = [{ pTag: pointATag, radian }];
    this.setRadian(pointInfoArr, true);
  }
  moveAllPoints(v: number) {
    const points = this.getRedPoints();
    const pointInfoArr = this.getRefRadians().map((ref, refI) => ({ pTag: points[refI].tag, radian: ref + v / 100 * (Math.PI / 3) }));
    this.setRadian(pointInfoArr, true)
  }
  generateRandomlyRadians() {
    const redPoints = this.getRedPoints();
    const currRadians = this.getRadians();
    const newRadians = getRandomUniqueNumbers(3, 0, 5).sort((a, b) => a - b);
    newRadians.map((v: number) => (v * (Math.PI / 3))).sort().reverse();
    moveAllPointAnim(currRadians, newRadians, (radian, index) => this.setRadian([{ pTag: redPoints[index].tag, radian }]));
  }
}
